/// material_type CHECK 値。DB 制約と同期。
export type SalesMaterialType =
  | 'service_deck'
  | 'proposal_deck'
  | 'pricing_sheet'
  | 'case_study'
  | 'contract_related'
  | 'other';

export const SALES_MATERIAL_TYPE_LABELS: Record<SalesMaterialType, string> = {
  service_deck: 'サービス資料',
  proposal_deck: '提案資料',
  pricing_sheet: '料金表',
  case_study: '事例',
  contract_related: '契約関連',
  other: 'その他',
};

/// One sales-supporting asset attached to a product. Mirrors the Rust
/// `ProductSalesMaterialDto` returned by
/// `/api/master/products/:id/sales-materials`.
export interface ProductSalesMaterial {
  id: string;
  product_id: string;
  title: string;
  url: string;
  material_type: SalesMaterialType;
  notes: string | null;
  sort_order: number;
  created_at: string;
  updated_at: string;
}

export interface ProductSalesMaterialList {
  items: ProductSalesMaterial[];
}

export interface ProductSalesMaterialCreateRequest {
  title: string;
  url: string;
  material_type?: SalesMaterialType;
  notes?: string | null;
  sort_order?: number;
}

/// PATCH body. `notes` uses the tri-state on the wire:
/// absent → keep, `null` → clear, string → overwrite.
export interface ProductSalesMaterialUpdateRequest {
  title?: string;
  url?: string;
  material_type?: SalesMaterialType;
  notes?: string | null;
  sort_order?: number;
}
